"use client";
import {
  DialogContextProvider,
  DialogScopedContextProvider
} from "./G6BJYYBK.js";
import {
  createStoreContext
} from "./3ORBWXWF.js";

// src/popover/popover-context.tsx
var ctx = createStoreContext(
  [DialogContextProvider],
  [DialogScopedContextProvider]
);
var usePopoverContext = ctx.useContext;
var usePopoverScopedContext = ctx.useScopedContext;
var usePopoverProviderContext = ctx.useProviderContext;
var PopoverContextProvider = ctx.ContextProvider;
var PopoverScopedContextProvider = ctx.ScopedContextProvider;

export {
  usePopoverContext,
  usePopoverScopedContext,
  usePopoverProviderContext,
  PopoverContextProvider,
  PopoverScopedContextProvider
};
